// LIVE create for Iron Condor / Box Spread: a red button shown ONLY when the server says LIVE is allowed for this
// account (status.live.allowed), and a confirmation dialog that lists the whole position to review before Confirm.
// It creates a PLANNED LIVE trade: real Zerodha orders go out only on Start.
import React, { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function LiveCreate({ live, disabled, underlying, lines, onConfirm, testId }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!live?.allowed) return null;
  const go = async () => {
    setBusy(true);
    try { await onConfirm(); setOpen(false); } finally { setBusy(false); }
  };
  return (
    <>
      <span className="text-[10px] font-bold px-1.5 py-0.5 rounded-sm bg-[#FF3B30] text-white">LIVE</span>
      <button type="button" disabled={disabled} onClick={() => setOpen(true)} data-testid={`${testId}-open`}
        className="h-8 px-3 rounded-sm bg-[#FF3B30] text-white text-xs font-bold disabled:opacity-40">Create LIVE trade</button>
      <Dialog open={open} onOpenChange={(v) => { if (!v && !busy) setOpen(false); }}>
        <DialogContent className="max-w-lg p-4 gap-3 bg-[var(--term-bg,var(--background))]" data-testid={`${testId}-dialog`}>
          <DialogHeader><DialogTitle className="text-sm text-[#FF3B30]">Create a LIVE trade — real Zerodha orders</DialogTitle>
            <DialogDescription className="text-[11px]">A PLANNED LIVE trade is created. Real orders are sent only when you press Start;
              margin and funds are re-checked then, and the trade always exits before expiry.</DialogDescription></DialogHeader>
          <div className="text-xs mono space-y-0.5" data-testid={`${testId}-summary`}>{(lines || []).map((l) => <div key={l}>{l}</div>)}</div>
          <div className="flex justify-end gap-2">
            <button type="button" className="h-8 px-3 rounded-sm border border-[var(--term-border-strong)] text-xs" onClick={() => setOpen(false)}>Cancel</button>
            <button type="button" disabled={busy || !underlying} onClick={go} data-testid={`${testId}-confirm`}
              className="h-8 px-3 rounded-sm bg-[#FF3B30] text-white text-xs font-bold disabled:opacity-40">Confirm — create LIVE trade</button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
